/**
 * クリエイターマイページ小説設定共通レイアウト
 */

import Link from "next/link"
import DefaultLayout from "./DefaultLayout"
import clsx from "clsx"
import routes from "../../../../routes"
import MyPageHeader from "../MyPageHeader"
import React from "react"
import { usePermission } from "src/components/hooks/usePermission"

type Props = {
  navActive?: "detail" | "outline" | "note" | "character" | "publish"
  novelId?: number
}

const NavLink: React.FC<{ href: string | undefined }> = ({
  children,
  href,
}) => {
  if (href) {
    return <Link href={href}>{children}</Link>
  }

  return <>{children}</>
}

const CreatorMyPageNovelSettingsLayout: React.FC<Props> = ({
  children,
  navActive,
  novelId,
}) => {
  usePermission([2])

  return (
    <DefaultLayout isCreatorMyPage={true}>
      <MyPageHeader title="小説詳細設定" />
      <nav className="p-creatorMypage-headerNav">
        <div className="p-creatorMypage-headerNav-inner">
          <ul className="p-creatorMypage-headerNav-list">
            <li>
              <NavLink
                href={
                  novelId
                    ? routes.creatorMyPageNovelsNovelDetail(novelId)
                    : undefined
                }
              >
                <a
                  aria-disabled={!novelId}
                  className={clsx({
                    "p-creatorMypage-headerNav-anchor": true,
                    "is-active": navActive === "detail",
                  })}
                >
                  基本情報
                </a>
              </NavLink>
            </li>
            <li>
              <NavLink
                href={
                  novelId
                    ? routes.creatorMyPageNovelsNovelOutline(novelId)
                    : undefined
                }
              >
                <a
                  aria-disabled={!novelId}
                  className={clsx({
                    "p-creatorMypage-headerNav-anchor": true,
                    "is-active": navActive === "outline",
                  })}
                >
                  あらすじ
                </a>
              </NavLink>
            </li>
            <li>
              <NavLink
                href={
                  novelId
                    ? routes.creatorMyPageNovelsNovelNote(novelId)
                    : undefined
                }
              >
                <a
                  aria-disabled={!novelId}
                  className={clsx({
                    "p-creatorMypage-headerNav-anchor": true,
                    "is-active": navActive === "note",
                  })}
                >
                  共有メモ
                </a>
              </NavLink>
            </li>
            <li>
              <NavLink
                href={
                  novelId
                    ? routes.creatorMyPageNovelsNovelCharacters(novelId)
                    : undefined
                }
              >
                <a
                  aria-disabled={!novelId}
                  className={clsx({
                    "p-creatorMypage-headerNav-anchor": true,
                    "is-active": navActive === "character",
                  })}
                >
                  キャラリスト
                </a>
              </NavLink>
            </li>
            <li>
              <NavLink
                aria-disabled={!novelId}
                href={
                  novelId
                    ? routes.creatorMyPageNovelsNovelPublicManagement(novelId)
                    : undefined
                }
              >
                <a
                  aria-disabled={!novelId}
                  className={clsx({
                    "p-creatorMypage-headerNav-anchor": true,
                    "is-active": navActive === "publish",
                  })}
                >
                  公開設定
                </a>
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
      <div className="l-column">
        <main className="l-column-main">{children}</main>
        <aside className="l-column-side">
          <nav className="p-creatorMypage-sideNav">
            <ul className="p-creatorMypage-sideNav-list">
              <li>
                <NavLink
                  href={
                    novelId
                      ? routes.creatorMyPageNovelsNovelDetail(novelId)
                      : undefined
                  }
                >
                  <a
                    aria-disabled={!novelId}
                    className={clsx({
                      "p-creatorMypage-sideNav-anchor": true,
                      "is-active": navActive === "detail",
                    })}
                  >
                    基本情報
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  href={
                    novelId
                      ? routes.creatorMyPageNovelsNovelOutline(novelId)
                      : undefined
                  }
                >
                  <a
                    aria-disabled={!novelId}
                    className={clsx({
                      "p-creatorMypage-sideNav-anchor": true,
                      "is-active": navActive === "outline",
                    })}
                  >
                    あらすじ
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  href={
                    novelId
                      ? routes.creatorMyPageNovelsNovelNote(novelId)
                      : undefined
                  }
                >
                  <a
                    aria-disabled={!novelId}
                    className={clsx({
                      "p-creatorMypage-sideNav-anchor": true,
                      "is-active": navActive === "note",
                    })}
                  >
                    共有メモ
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  href={
                    novelId
                      ? routes.creatorMyPageNovelsNovelCharacters(novelId)
                      : undefined
                  }
                >
                  <a
                    aria-disabled={!novelId}
                    className={clsx({
                      "p-creatorMypage-sideNav-anchor": true,
                      "is-active": navActive === "character",
                    })}
                  >
                    キャラリスト
                  </a>
                </NavLink>
              </li>
              <li>
                <NavLink
                  aria-disabled={!novelId}
                  href={
                    novelId
                      ? routes.creatorMyPageNovelsNovelPublicManagement(novelId)
                      : undefined
                  }
                >
                  <a
                    aria-disabled={!novelId}
                    className={clsx({
                      "p-creatorMypage-sideNav-anchor": true,
                      "is-active": navActive === "publish",
                    })}
                  >
                    公開設定
                  </a>
                </NavLink>
              </li>
            </ul>
          </nav>
        </aside>
      </div>
    </DefaultLayout>
  )
}

export default CreatorMyPageNovelSettingsLayout
